import { cn, rgbDataURL } from "@/components/common/utils";
import Image from "next/image";

interface SpecialCardImageProps {
  width: number;
  height: number;
  comedianDisplayName: string | null;
  imgSrc: string | null;
  unlocked: boolean;
  className?: string;
}

export default function SpecialCardImage({
  width,
  height,
  comedianDisplayName,
  imgSrc,
  unlocked,
  className,
}: SpecialCardImageProps) {
  if (!imgSrc) return null;

  return (
    <div
      className={cn("relative rounded-xl", className)}
      style={{ width, height }}
    >
      <Image
        src={imgSrc}
        alt={`Promotional image for ${comedianDisplayName}'s comedy special.`}
        fill
        placeholder="blur"
        blurDataURL={rgbDataURL(16, 16, 16)}
        className={cn(
          "object-cover object-top bg-neutral-300 transition-all lg:group-hover:scale-105 duration-150 group-hover:ease-in-out",
          unlocked ? "" : "grayscale"
        )}
      />
    </div>
  );
}
